import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetchWithCsrf } from "@/lib/api";
import { useNavigate } from "react-router";
import { CURRENT_USER_QUERY_KEY } from "./useCurrentUser";
import type { LoginCredentials, User } from "@/types/auth";
import type { ApiSuccess, ApiError } from "@/types/api";

interface LoginResponse {
  user: User;
}

export function useLogin() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation<ApiSuccess<LoginResponse>, ApiError, LoginCredentials>({
    mutationFn: async (credentials) => {
      return fetchWithCsrf("/api/session", {
        method: "POST",
        body: JSON.stringify(credentials),
      });
    },
    onSuccess: (response) => {
      queryClient.setQueryData(CURRENT_USER_QUERY_KEY, response.data.user);
      navigate("/");
    },
  });
}
